<template>
  <div id="RS_changeDetection">
    <div class="font">
      <span class="introSubTitle"><b>遥感影像变化检测系统</b></span>
      <p class="textStyle">遥感影像变化检测是利用不同时期覆盖同一地表区域的多源遥感影像，结合相应地物特性和遥感成像机理，采用图像处理理论及数理模型方法，分析地物位置、范围、属性的变化。自动的变化检测技术对发掘遥感影像的潜力、保持地理空间数据的现势性具有重要意义，在国民经济、国防建设等各方面发挥着重要作用。针对这一重大需求，本团队研发了遥感影像通用变化检测系统，同时支持遥感影像二维和三维变化检测。该系统集成了遥感影像几何预处理、辐射预处理、变化检测整体流程，在输入两幅具有空间重叠区域的遥感影像后，能自动校正影像之间的几何、辐射差异，提取地物覆盖发生的变化。该系统采用插件式框架进行开发，能自由嵌入到其它应用系统中，灵活度较高。</p>
    </div>
   <!-- <br/>   -->
    <img width="100%" src="@/assets/img/scientific/RS_changeDetection-4.png" />
    <p class="img_figure">二维变化检测</p>
    <img width="100%" src="@/assets/img/scientific/RS_changeDetection-3.png" />
    <p class="img_figure">三维变化检测</p>
    <!-- <div class="container">
      <my-video :sources="video.sources" :options="video.options"></my-video>
    </div> -->
  </div>
</template>

<script>
// import myVideo from "vue-video";

export default {
  data() {
    return {
      // video: {
      //   sources: [
      //     {src: require("@/assets/static/Quick_change.mp4"), type:"video/mp4"},
      //   ],
      //   options: {
      //     autoplay: true,
      //     volume: 0.6,
      //   },
      // },
    };
  },
  // components: {
  //   myVideo,
  // },
};
</script>

<style lang="less">
#RS_changeDetection {
  margin-top: 20px;
  .img_figure{
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #4f4f4f;
  }
  // .font {
  //   // font-family: "Times New Roman", Times, serif;
  // }
}
</style>
